const login = () => import('./components/login/login.vue');
const members = () => import('./components/members/members.vue');
const archive = () => import('./components/archive/archive.vue');

const users = () => import('./components/admin/users/users.vue');
const userform = () => import('./components/admin/users/form.vue');
// const exports = () => import('./components/admin/excel_exports/excel_exports.vue');
const report_settings = () => import('./components/admin/report_settings/report_settings.vue');
const providers = () => import('./components/admin/providers/providers.vue');
const sites = () => import('./components/admin/sites/sites.vue');
const siteform = () => import('./components/admin/sites/form.vue');

// Import forms (lazy-loaded)
const cardinalForm = () => import('./components/forms/cardinal.vue');
const mckessonForm = () => import('./components/forms/mckesson.vue');
const abcForm = () => import('./components/forms/abc.vue');
const thanks = () => import('./components/forms/thanks.vue');

export default [
    {
        path: '/',
        alias: '/login',
        name: 'login',
        component: login,
        meta: {
            guest: true
        }
    },
    {
        path: '/members',
        name: 'members',
        component: members,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/archive',
        name: 'archive',
        component: archive,
        meta: {
            requiresAuth: true
        }
    },


    // Enrollment forms
    {
        path: '/forms/cardinal',
        alias: '/forms/possr',
        name: 'cardinalForm',
        component: cardinalForm,
        meta: {
            //guest: true
        }
    },

    {
        path: '/forms/mckesson',
        alias: '/forms/fei',
        name: 'mckessonForm',
        component: mckessonForm,
        meta: {
            //guest: true
        }
    },

    {
        path: '/forms/abc',
        alias: '/forms/mck',
        name: 'abcForm',
        component: abcForm,
        meta: {
            //guest: true
        }
    },

    // Enrollment forms
    {
        path: '/forms/thanks',
        name: 'thanks',
        component: thanks,
        meta: {
            //guest: true
        }
    },


    // Admin routes
    {
        path: '/admin/users',
        name: 'users',
        component: users,
        meta: {
            admin: true
        }
    },
    {
        path: '/admin/users/add',
        name: 'adduser',
        component: userform,
        meta: {
            admin: true
        }
    },
    {
        path: '/admin/users/:id',
        name: 'edituser',
        component: userform,
        meta: {
            admin: true
        }
    },
    {
        path: '/admin/report_settings',
        name: 'report_settings',
        component: report_settings,
        meta: {
            admin: true
        }
    },
    {
        path: '/admin/providers',
        name: 'providers',
        component: providers,
        meta: {
            admin: true
        }
    },
    {
        path: '/admin/sites',
        name: 'sites',
        component: sites,
        meta: {
            admin: true
        }
    },
    {
        path: '/admin/sites/add',
        name: 'addsite',
        component: siteform,
        meta: {
            admin: true
        }
    },
    {
        path: '/admin/sites/:id',
        name: 'editsite',
        component: siteform,
        meta: {
            admin: true
        }
    },



    // Default 404
    { path: '/:pathMatch(.*)*', redirect: '/' },
];
